<template>
  <!-- sign in start -->
  <section class="authentication-form">
    <div class="pt-4">
      <h2 class="title text-center pt-4">
        <span> Login</span>
      </h2>
      <p class="text-center">
        Welcome to ezFix'd, Please Login with your personal account information.
      </p>
      <div class="card">
        <form
          class="theme-form"
          @submit.prevent
        >
          <div class="form-group">
            <input
              v-model="input.email"
              type="email"
              class="form-control"
              placeholder="email address"
              required="required"
            >
          </div>
          <div class="form-group">
            <input
              v-model="input.password"
              :type="showpassword ? 'password' : 'text'"
              required="required"
              class="form-control"
              placeholder="Password"
            >
            <div
              class="show-hide"
              @click="showpassword = !showpassword"
            >
              <span :class="{show:showpassword}" />
            </div>
          </div>
          <div class="form-group row">
            <div class="custom-control custom-checkbox col-6">
              <input
                id="customControlAutosizing"
                type="checkbox"
                class="custom-control-input"
              >
              <label
                class="custom-control-label"
                for="customControlAutosizing"
              >Remember me</label>
            </div>
            <a
              href="forget-password"
              class="text-right col-6 theme-link"
            >lost your password</a>
          </div>
          <div class="form-button text-center">
            <button
              type="submit"
              class="btn btn-custom btn-lg theme-color"
              @click="login"
            >
              Login
            </button>
          </div>
          <div class="error hide">
            User email or password is incorrect
          </div>
        </form>
      </div>
    </div>
  </section>
  <!-- sign in end-->
</template>
<style>
.error {
  padding: 15px 0;
  color: red;
}
.error.hide {
  display: none;
}
</style>
<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import $ from 'jquery'

export default {
  name: 'Signin',
  data() {
    return {
      showpassword: true,
      input: {
        email: null,
        password: null,
      },
    }
  },
  watch: {
    'input.email': {
      handler: function(after, before) {
        this.input.email = this.input.email.toLowerCase()
        console.log(this.input.email)
      },
      deep: true,
    },
  },
  mounted: function() {
    $('.navbar').addClass('darkHeader')
  },
  methods: {
    login() {
      $('.error').addClass('hide')
      console.log('logging in')
      this.axios
        .post(`${process.env.ROOT_API}/user/signin`, {
          email: this.input.email,
          password: this.input.password,
        })
        .then(response => {
          location.href = `${process.env.DASHBOARD_URL}/#/login?token=${response.data.user.token}`
        })
        .catch(error => {
          this.$toasted.show('An error occurred please try again')
          $('.error').removeClass('hide')
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/sign_in.vue